import sipFutureValue from "./configs/sipFutureValue";
import lumpsumFutureValue from "./configs/lumpsumFutureValue";
import stepUpSipFutureValue from "./configs/stepUpSipFutureValue";
import fvAnnualLumpsum from "./configs/fvAnnualLumpsum";
import fvLimitedPeriodSip from "./configs/fvLimitedPeriodSip";
import fvLumpsumPlusSip from "./configs/fvLumpsumPlusSip";
import fvStp from "./configs/fvStp";
import fvSipPlusStp from "./configs/fvSipPlusStp";
import reqAnnualLumpsum from "./configs/reqAnnualLumpsum";
import reqLumpsum from "./configs/reqLumpsum";
import reqSipCostOfDelay from "./configs/reqSipCostOfDelay";
import reqSipOrLumpsum from "./configs/reqSipOrLumpsum";
import reqSipOrStp from "./configs/reqSipOrStp";
import reqStepUpSip from "./configs/reqStepUpSip";
import reqStp from "./configs/reqStp";
import reqLumpsumForSwp from "./configs/reqLumpsumForSwp";
import reqSipForSwp from "./configs/reqSipForSwp";
import reqLimitedPeriodSip from "./configs/reqLimitedPeriodSip";
import salaryWealthCreation from "./configs/salaryWealthCreation";
import recoverEmiThroughSip from "./configs/recoverEmiThroughSip";
import propertyRentalYield from "./configs/propertyRentalYield";
import customGoal from "./configs/customGoal";
import childEducation from "./configs/childEducation";
import childWedding from "./configs/childWedding";
import dreamHome from "./configs/dreamHome";
import dreamCar from "./configs/dreamCar";
import dreamVacation from "./configs/dreamVacation";
import retirementPlanning from "./configs/retirementPlanning";
import swpIncomeFromCorpus from "./configs/swpIncomeFromCorpus";
import swpMonthlyForLumpsum from "./configs/swpMonthlyForLumpsum";
import swpMonthlyForSip from "./configs/swpMonthlyForSip";
import swpComprehensive from "./configs/swpComprehensive";
import swpPeriodic from "./configs/swpPeriodic";
import swpRebalance from "./configs/swpRebalance";
import hlvTermInsurance from "./configs/hlvTermInsurance";
import insuranceIrr from "./configs/insuranceIrr";
import insuranceSurrender from "./configs/insuranceSurrender";
import insuranceVsTermSip from "./configs/insuranceVsTermSip";
import termPlusSip from "./configs/termPlusSip";
import termPlusSipNeed from "./configs/termPlusSipNeed";
import assetAllocation from "./configs/assetAllocation";
import rrLumpsum from "./configs/rrLumpsum";
import rrSipFv from "./configs/rrSipFv";
import rrSipStepup from "./configs/rrSipStepup";
import rrSipSwp from "./configs/rrSipSwp";
import rrStpFv from "./configs/rrStpFv";
import rrSipNeed from "./configs/rrSipNeed";
import rrStpNeed from "./configs/rrStpNeed";
import rrLumpsumNeed from "./configs/rrLumpsumNeed";
import capitalGainsTax from "./configs/capitalGainsTax";
import capitalGainsBond from "./configs/capitalGainsBond";
import debtFundHoldSell from "./configs/debtFundHoldSell";
import sipComprehensive from "./configs/sipComprehensive";
import stpComprehensive from "./configs/stpComprehensive";
import multipurpose from "./configs/multipurpose";
import leanFireNumber from "./configs/leanFireNumber";
import licPolicyAnalyzer from "./configs/licPolicyAnalyzer";

/**
 * Every calculator config lives here. Adding a calculator = adding one entry — no new pages,
 * no new routes beyond the generic /calculators/:key one (CLAUDE.md architecture rule).
 * The six goal calculators (custom + child education/wedding, dream home/car/vacation) share one
 * factory (makeGoalCalculator) so they aren't six copies of the same maths.
 *
 * Calculator keys are immutable once shipped (Task 14 rule) — members save scenarios by key.
 */
export const CALCULATORS = [
  sipFutureValue,
  lumpsumFutureValue,
  stepUpSipFutureValue,
  fvAnnualLumpsum,
  fvLimitedPeriodSip,
  fvLumpsumPlusSip,
  fvStp,
  fvSipPlusStp,
  reqAnnualLumpsum,
  reqLumpsum,
  reqSipCostOfDelay,
  reqSipOrLumpsum,
  reqSipOrStp,
  reqStepUpSip,
  reqStp,
  reqLumpsumForSwp,
  reqSipForSwp,
  reqLimitedPeriodSip,
  salaryWealthCreation,
  recoverEmiThroughSip,
  propertyRentalYield,
  customGoal,
  childEducation,
  childWedding,
  dreamHome,
  dreamCar,
  dreamVacation,
  retirementPlanning,
  swpIncomeFromCorpus,
  swpMonthlyForLumpsum,
  swpMonthlyForSip,
  swpComprehensive,
  swpPeriodic,
  swpRebalance,
  hlvTermInsurance,
  insuranceIrr,
  insuranceSurrender,
  insuranceVsTermSip,
  termPlusSip,
  termPlusSipNeed,
  assetAllocation,
  rrLumpsum,
  rrSipFv,
  rrSipStepup,
  rrSipSwp,
  rrStpFv,
  rrSipNeed,
  rrStpNeed,
  rrLumpsumNeed,
  capitalGainsTax,
  capitalGainsBond,
  debtFundHoldSell,
  sipComprehensive,
  stpComprehensive,
  multipurpose,
  leanFireNumber,
  licPolicyAnalyzer,
];

export function getCalculatorByKey(key) {
  return CALCULATORS.find((c) => c.key === key);
}
